<template>
  <div class="otherbox">
    <!-- 财产信息 -->

    <div class="htit htit1" style="margin:0;">
      <div class="h2">财产信息</div>
      <!-- <div class="rt" v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:add")'>
        <a-button icon="plus" @click='AddSelection()'>添加</a-button>
      </div> -->
    </div>
    <div style="width:100%;overflow:hidden;">
      <div class="insetbox">
        <div class="cselect">
          <a-radio-group name="radioGroup" button-style="solid" v-model='carOrHouse' @change="getCarOrHouseList">
            <a-radio :value="1" style="font-size: 15px;">车辆</a-radio>
            <a-radio :value="3" style="font-size: 15px;">账户</a-radio>
            <a-radio :value="2" style="font-size: 15px;">房产</a-radio>
          </a-radio-group>
        </div>
        <div class="ntable table" :style="showPadding ? 'padding-bottom: 20px;' : ''">
          <table cellpadding="0" cellspacing="0" class="operation-table">
            <thead v-if="carOrHouse === 1">
              <td width='40'>序号</td>
              <td width='150'>车辆品牌</td>
              <td width='80'>规格信息</td>
              <td width='145'>登记信息</td>
              <td width='110'>估值记录</td>
              <td width='65'>车辆状态</td>
              <td width='95'>保全状态</td>
              <td width='160'>拍卖信息</td>
              <!-- <td width='110' class="operation-col">操作</td> -->
            </thead>
            <tbody v-if="carOrHouse === 1 && carlist.length > 0">
              <tr v-for='(j, ind) in carlist' :key='j.id'>
                <td>{{ ind + 1 }}</td>
                <td>
                  <Normap v-if="j.only_show != 1" :tit="j.car ? j.car.name : ''"></Normap>
                  <div v-else>/</div>
                </td>
                <td>
                  <div v-if="j.only_show != 1">
                    <Normap :tit="'颜色：' + j.color"></Normap>
                    <Normap :tit="j.car.displacement ? '排量：' + j.car.displacement : '排量：' + '/'"></Normap>
                    <Normap :tit="j.car.environmentalstandards ? '排放：' + j.car.environmentalstandards : '排放：' + '/'">
                    </Normap>
                  </div>
                  <div v-else>/</div>
                </td>
                <td>
                  <div v-if="j.only_show != 1">
                    <Normap :tit="j.car ? '车架号：' + j.car.vin : ''"></Normap>
                    <Normap :tit="'车辆登记人：' + j.debtor.realname"></Normap>
                    <Normap :tit="'车牌号码：' + j.number"></Normap>
                    <Normap :tit="'初登日期：' + j.registration_time.slice(0, 10) || '初登日期：' + yearFormats.slice(0, 10)">
                    </Normap>
                    <Normap :tit="j.mortgagee ? '抵押权人：' + j.mortgagee : '抵押权人：' + '/'"></Normap>
                  </div>
                  <div v-else>/</div>
                </td>
                <td>
                  <div class="auction-card" v-if="j.valuationList.length > 0">
                    <div v-for="row in j.valuationList" :key="row.id" class="auction-item">
                      <Normap :tit="'时间：' + row.valuation_time.slice(0, 10)"></Normap>
                      <Normap :tit="'金额：' + row.valuation_fee"></Normap>
                    </div>
                  </div>
                  <div v-else style="margin-left: 20px;">/</div>
                </td>
                <td>
                  <Normap :tit="transformedValue(j.state, 2)"></Normap>
                </td>
                <td>
                  <div v-if="j.preservation_time">
                    <Normap v-if="j.only_show != 1" :tit="transformedValue(j.preservation_status, 1)"></Normap>
                    <Normap v-else :tit="j.car.name"></Normap>
                    <Normap :tit="'保全时间：' + yearFormats(j.preservation_time)"></Normap>
                    <Normap :tit="'到期时间：' + yearFormats(j.preservation_expired_time)"></Normap>
                  </div>
                  <div v-else>/</div>
                </td>
                <td>
                  <div class="auction-card" v-if="j.auctionList.length > 0">
                    <div v-for="(item, index) in j.auctionList" :key="index" class="auction-item">
                      <Normap :tit="'阶段：' + transformation(item.auction_status, 'auction_status')"></Normap>
                      <Normap :tit="'状态：' + transformation(item.auction_step, 'auction_step')"></Normap>
                      <Normap :tit="'估值：' + item.value / 100"></Normap>
                      <Normap :tit="'开始时间：' + item.auction_start_time"></Normap>
                    </div>
                  </div>
                  <div v-else style="margin-left: 20px;">/</div>
                </td>
                <!-- <td class="operation-col">
                  <div class="operation-btn-group" v-if="j.only_show != 1">
                    <a href='javascript:void(0);' @click='edit(j, true, "车辆")'
                      v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>查看</a>
                    <a href='javascript:void(0);' @click='edit(j, false, "车辆")'
                      v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:edit")'><span class="line"></span>修改</a>
                    <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delCar(j.id)'
                      v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:delete")'>
                      <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
                    </a-popconfirm>
                  </div>
                  <div class="operation-btn-group" v-else>
                    <a-popconfirm title="确认续封此条数据吗?"
                      v-if='j.always == 0 && $common.AccAUTH(debInfo.accuser_id, "debtor:keep:always")' ok-text="确定"
                      cancel-text="取消" @confirm='cold(j.id, j)'>
                      <a href='javascript:void(0);'>续封</a>
                    </a-popconfirm>
                    <span v-else>/</span>
                  </div>
                </td> -->
              </tr>
            </tbody>
            <thead v-if="carOrHouse === 3">
              <td width='40'>序号</td>
              <td width='70'>账户类型</td>
              <td width='190'>开户行</td>
              <td width='100'>户名</td>
              <td width='130'>银行账号</td>
              <td width='90'>账户状态</td>
              <td width='90'>保全状态</td>
              <td width='90'>保全时间</td>
              <td width='90'>保全到期时间</td>
              <!-- <td width='130'>操作</td> -->
            </thead>
            <tbody v-if="carOrHouse === 3 && mockAccountData.length > 0">
              <tr v-for='(i, index) in mockAccountData' :key='index'>
                <td>{{ index + 1 }}</td>
                <td>
                  {{ transformation(i.account_type, 'account_type') }}
                </td>
                <td>
                  <Normap v-if='i.only_show != 1' :tit="i.opening_bank"></Normap>
                  <div v-else>/</div>
                </td>
                <td>
                  <Normap v-if='i.only_show != 1' :tit="i.debtor.realname"></Normap>
                  <div v-else>/</div>
                </td>
                <td>
                  <Normap :tit="i.account_bank"></Normap>
                </td>
                <td>{{ i.account_status | account_status }}</td>
                <td>
                  <Normap v-if='i.only_show != 1' :tit="transformedValue(i.preservation_status, 1)"></Normap>
                  <Normap v-else :tit="i.opening_bank"></Normap>
                </td>
                <td>
                  <div v-if="i.preservation_time">
                    <Normap :tit="yearFormats(i.preservation_time)"></Normap>
                  </div>
                  <div v-else>/</div>
                </td>
                <td>
                  <div v-if="i.preservation_expired_time">
                    <Normap :tit="yearFormats(i.preservation_expired_time)"></Normap>
                  </div>
                  <div v-else>/</div>
                </td>
                <!-- <td>
                  <div style="display:inline-block;" v-if='!disabled && i.only_show != 1'>
                    <a href='javascript:void(0);' @click='edit(i, true, "账户")'
                      v-if='disabled || $common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:index")'>查看</a>
                    <span class="line"
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:edit")'></span>
                    <a href='javascript:void(0);' @click='edit(i, false, "账户")'
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:edit")'>修改</a>
                    <span class="line"
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:del")'></span>
                    <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delAccount(i.id)'
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:del")'>
                      <a href='javascript:void(0);' style="color:#f00;">删除</a>
                    </a-popconfirm>
                  </div>
                  <div class="operation-btn-group" v-else>
                    <a-popconfirm title="确认续封此条数据吗?"
                      v-if='i.always == 0 && $common.AccAUTH(debInfo.accuser_id, "debtor:keep:always")' ok-text="确定"
                      cancel-text="取消" @confirm='cold(i.id, i)'>
                      <a href='javascript:void(0);'>续封</a>
                    </a-popconfirm>
                    <span v-else>/</span>
                  </div>
                </td> -->
              </tr>
            </tbody>
            <thead v-if="carOrHouse === 2">
              <td width='40'>序号</td>
              <td width='180'>房产地址</td>
              <td width='180'>产权人信息</td>
              <td width='110'>房屋信息</td>
              <td width='110'>抵押权人</td>
              <td width='90'>保全状态</td>
              <td width='90'>保全时间</td>
              <td width='90'>保全到期时间</td>
              <!-- <td width='130'>操作</td> -->
            </thead>
            <tbody v-if="carOrHouse === 2 && realEstate.length > 0">
              <tr v-for='(i, index) in realEstate' :key='index'>
                <td>{{ index + 1 }}</td>
                <td>
                  <Normap v-if='i.only_show != 1'
                    :tit="i.province + i.city + i.district + (i.detail_address ? i.detail_address : '')"></Normap>
                  <div v-else>/</div>
                </td>
                <td>
                  <div v-if="i.only_show != 1">
                    <Normap :tit="'姓名：' + i.debtor.realname"></Normap>
                    <Normap :tit="'身份证号码：' + i.debtor.chinaid"></Normap>
                    <Normap :tit="'产权证书号：' + i.cert_no"></Normap>
                  </div>
                  <div v-else>/</div>
                </td>
                <td>
                  <div v-if="i.only_show != 1">
                    <div>土地使用权面积：{{ i.land_area }}</div>
                    <div>房屋建筑面积：{{ i.build_area }}</div>
                    <div>房屋性质：{{ transformation(i.nature, 'housestate') }}</div>
                    <div>房屋状态：{{ transformation(i.state, 'housestatus') }}</div>
                  </div>
                  <div v-else>/</div>
                </td>
                <td>
                  <Normap :tit="i.mortgagee"></Normap>
                </td>
                <td>
                  <Normap v-if='i.only_show != 1' :tit="transformedValue(i.preservation_status, 1)"></Normap>
                  <Normap v-else :tit="i.detail_address"></Normap>
                </td>
                <td>
                  <Normap v-if="i.preservation_time" :tit="yearFormats(i.preservation_time)"></Normap>
                  <div v-else>/</div>
                </td>
                <td>
                  <Normap v-if="i.preservation_expired_time" :tit="yearFormats(i.preservation_expired_time)"></Normap>
                  <div v-else>/</div>
                </td>
                <!-- <td>
                  <div style="display:inline-block;" v-if="i.only_show != 1">
                    <a href='javascript:void(0);' @click='edit(i, true, "房产")'
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:index")'>查看</a>
                    <span class="line"
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:edit")'></span>
                    <a href='javascript:void(0);' @click='edit(i, false, "房产")'
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:edit")'>修改</a>
                    <span class="line"
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:del")'></span>
                    <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delhouse(i.id)'
                      v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:keep:del")'>
                      <a href='javascript:void(0);' style="color:#f00;">删除</a>
                    </a-popconfirm>
                  </div>
                  <div class="operation-btn-group" v-else>
                    <a-popconfirm title="确认续封此条数据吗?"
                      v-if='i.always == 0 && $common.AccAUTH(debInfo.accuser_id, "debtor:keep:always")' ok-text="确定"
                      cancel-text="取消" @confirm='cold(i.id, i)'>
                      <a href='javascript:void(0);'>续封</a>
                    </a-popconfirm>
                    <span v-else>/</span>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div class="solids" v-if='carlist.length > 0 && type == 1'></div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCarList, DelCar } from '@/server/car.js'
import { getAccountList, DelAccount, DelHouse } from '@/server/account.js'
import { auction } from '@/server/debtor'
import { debtorKeepAdd, debtorKeepDel, debtorKeepEdit, keepAlways } from "@/server/debtor"
import {
  yearFormats
} from '@/assets/js/formData'
export default {
  props: {
    byTypeObject: Object,
    List: {
      type: Array,
      default() {
        return []
      }
    },
    iData: {
      type: Object,
      default() {
        return {}
      }
    },
    disabled: Boolean,
    id: Number
  },

  name: 'CarList',
  data() {
    return {
      carOrHouse: 1,
      CarInfo: {},
      carlist: [],
      page: 1,
      item_type: 1,
      list: {},
      total: '',
      see: false,
      realEstate: [],
      mockAccountData: []
    }
  },
  filters: {
    Property(val) {
      const tit = {
        1: '住宅',
        2: '商业',
        3: '其他'
      }
      return tit[val]
    },
    House(val) {
      const tit = {
        1: '自住',
        2: '出租',
        3: '空置'
      }
      return tit[val]
    },
    Account(val) {
      const tit = {
        1: '储蓄账户',
        2: '活期账户',
        3: '定期账户'
      }
      return tit[val]
    },
    account_status(val) {
      const tit = {
        1: '挂失',
        2: '销户',
        3: '冻结',
        4: '正常使用'
      }
      return tit[val]
    }
  },
  computed: {
    showPadding() {
      let hasData = false;
      switch (this.carOrHouse) {
        case 1:
          hasData = this.carlist.length > 0;
          break;
        case 2:
          hasData = this.realEstate.length > 0;
          break;
        case 3:
          hasData = this.mockAccountData.length > 0;
          break;
        default:
          hasData = false;
      }
      return !hasData;
    },
    ...mapGetters([
      'debInfo',
    ])
  },
  mounted() {

    this.getCarOrHouseList()
    // const id = this.id
    // auction({ cause_id: id, item_type: this.item_type, page: this.page, limit: 5 }, 'index').then(e => {
    //   this.total = e.count
    //   this.list = e.list[0]
    // })
  },
  methods: {

    yearFormats,
    defendantValue(val) {
      const item = this.iData.parties.defendant.find(e => e.id == val);
      return item ? item.realname : '';
    },
    transformedValue(val, type) {
      let preservationStatus = [];
      if (!this.byTypeObject) return val;
      if (type === 1) {
        preservationStatus = this.byTypeObject.preservation_status || [];
      } else {
        preservationStatus = this.byTypeObject.car_status || [];
      }
      const matchedOption = preservationStatus.find(item => {
        if (type === 2) {//车辆状态
          return item.id === Number(val) || item.id === val;
        }
        return item.code === Number(val) || item.code === val;//保全状态
      });

      return matchedOption ? matchedOption.option_name : val;
    },
    transformation(id, type) {
      const stage = { 1: "一拍", 2: "二拍", 3: "变卖" };
      const status = { 1: "即将开始", 2: "扣押中", 3: "拍卖中", 4: "已拍卖", 5: "流拍" };
      const types = { 1: '储蓄账户', 2: '活期账户', 3: '定期账户' };
      const housestatus = { 1: '自住', 2: '出租', 3: '空置' };
      const housestate = { 1: '住宅', 2: '商业', 3: '其他' };

      let mapping = {};
      switch (type) {
        case 'auction_status':
          mapping = status;
          break;
        case 'account_type':
          mapping = types;
          break;
        case 'housestatus':
          mapping = housestatus;
          break;
        case 'housestate':
          mapping = housestate;
          break;
        default:
          mapping = stage;
      }
      return mapping[id] || mapping[String(id)] || id;
    },
    edit(item, bool, title) {
      this.see = bool
      this.CarInfo = Object.assign({ clarify: title }, item);
      this.visibleShow("Car")
    },
    cold(id, i) {
      keepAlways({ id: id }).then(e => {
        i.always = 1
        this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
        this.$message.success({ content: '续封', key: 'updatable' });
      })
    },
    del(id) {
      debtorKeepDel({ id: id }).then(e => {
        this.$message.success({ content: '删除成功', key: 'updatable' });
        this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
      })
    },
    AddSelection() {
      this.see = null
      if (this.carOrHouse == '1') {
        this.CarInfo = {
          clarify: '车辆'
        };
      } else if (this.carOrHouse == '3') {
        this.CarInfo = {
          clarify: '账户'
        };
      } else {
        this.CarInfo = {
          clarify: '房产'
        };
      }
      this.visibleShow("Car")
    },
    async getCarOrHouseList() {
      const id = this.id
      const data = await getAccountList({
        cause_id: id,
        type: 'all'
      })
      this.carlist = data.lists.car
      this.mockAccountData = data.lists.account
      this.realEstate = data.lists.house
    },
    async delCar(id) {
      await DelCar({ id })
      this.$message.success({ content: '删除成功', key: 'updatable' });
      this.getCarOrHouseList()
    },
    async delAccount(id) {
      await DelAccount({ id })
      this.$message.success({ content: '删除成功', key: 'updatable' });
      this.getCarOrHouseList()
    },
    async delhouse(id) {
      await DelHouse({ id })
      this.$message.success({ content: '删除成功', key: 'updatable' });
      this.getCarOrHouseList()
    },
    visibleShow(name) {
      this.$store.dispatch("openkey", {
        key: name,
        by: true
      })
    },
  }
}
</script>
<style lang="less" scoped>
.auction-card {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.auction-item {
  // background-color: #b7e4f831;
  border-radius: 4px;
  padding: 4px 8px;
}

/* 操作列整体右对齐 */
.operation-table .operation-col {
  text-align: left;
  /* 单元格内容右对齐 */
  padding-right: 10px;
  /* 可选：加右侧内边距，避免贴边 */
}

/* 操作按钮容器：确保不换行，且元素紧凑排列 */
.operation-btn-group {
  display: flex;
  /* 弹性布局，让按钮横向排列 */
  flex-wrap: nowrap;
  /* 强制不换行（核心） */
  justify-content: flex-start;
  /* 容器内元素右对齐，配合单元格的text-align */
  align-items: center;
  /* 垂直居中 */
  white-space: nowrap;
  /* 兜底：防止文本换行 */
}

.cselect {
  padding-left: 20px;
  height: 60px;
  line-height: 60px;
}

/* 可选：调整按钮之间的分隔线和间距，优化显示 */
.operation-btn-group a {
  margin: 0 4px;
  /* 按钮之间加间距 */
  white-space: nowrap;
  /* 单个按钮文本不换行 */
}

.operation-btn-group .line {
  /* 分隔线样式优化，避免换行影响 */
  display: inline-block;
  width: 1px;
  height: 12px;
  background: #ccc;
  margin: 0 7px 0 0;
  vertical-align: middle;
}

.bot {
  text-align: center;
  padding-top: 30px;
}
</style>